export const DRAFT_KEY='uogorod-home-journal-v2';
export const PENDING_KEY='uogorod-home-journal-transfer-v1';
const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const numbers=['count','preseedling','seedling','plants'],dates=['sowing','germination','picking','ground','harvest'];
const fail=()=>{throw Error('Проверьте данные демо-журнала. Черновик не удалён.');};
function text(v,max){if(v==null)return '';if(typeof v!=='string'||v.length>max||v.includes('\0'))fail();return v;}
export function normalizeHomepageDraft(input){
 if(!input||typeof input!=='object'||Array.isArray(input)||JSON.stringify(input).length>6000000)fail();
 const clientId=input.clientId;if(!UUID.test(clientId||''))fail();
 const name=text(input.name,60).trim()||'Мой огород',activeYear=Number(input.year);
 if(!Number.isInteger(activeYear)||activeYear<1900||activeYear>2100)fail();
 if(!input.records||typeof input.records!=='object'||Array.isArray(input.records))fail();
 const rows=[],results={};let photoBytes=0;
 for(const[year,records]of Object.entries(input.records)){
  const season=Number(year);if(!/^\d{4}$/.test(year)||season<1900||season>2100||!Array.isArray(records)||records.length>100)fail();
  const seen=new Set();
  for(const r of records){if(!r||!Number.isSafeInteger(r.id)||r.id<=0||seen.has(r.id))fail();seen.add(r.id);
   const entry={comment:text(r.comment,4000),label:text(r.label,50)};
   for(const key of numbers){const n=r[key];if(n==null||n==='')continue;if(!/^\d{1,4}$/.test(String(n)))fail();entry[key]=Number(n);}
   for(const key of dates){const d=r[key];if(d==null||d==='')continue;if(typeof d!=='string'||!/^\d{4}-\d{2}-\d{2}$/.test(d)||d<'1900-01-01'||d>'2100-12-31')fail();const parsed=new Date(d+'T00:00:00Z');if(!Number.isFinite(+parsed)||parsed.toISOString().slice(0,10)!==d)fail();entry[key]=d;}
   const photo=text(r.photo,1400000);if(photo&&!/^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/]+={0,2}$/.test(photo))fail();photoBytes+=photo.length;
   rows.push({seedId:r.id,season,entry,photo});
  }
  const note=text(input.results?.[year],6000);if(note)results[year]=note;
 }
 if(!rows.length||rows.length>100||Object.keys(input.records).length>10||photoBytes>5000000)fail();
 return {version:1,clientId,name,activeYear,rows,results};
}
export function transferCounts(draft){return {records:draft.rows.length,seasons:[...new Set(draft.rows.map(r=>r.season))].sort(),notes:draft.rows.filter(r=>r.entry.comment).length};}
export function signupIdentity(input){
 const email=text(input?.email,254).trim().toLowerCase(),name=text(input?.name,100).trim(),nickname=text(input?.nickname,80).trim().toLowerCase();
 if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)||!name||!nickname||/[\u0000-\u001f]/.test(name+nickname))throw Error('Укажите имя, никнейм и корректный адрес почты.');
 return {email,name,nickname};
}

// Imported season summaries are stored in the garden's existing about field.
// Return plain text for Vue interpolation; never render arbitrary about HTML.
export function homepageSeasonNote(about,year){
 if(!/^\d{4}$/.test(String(year))||typeof about!=='string')return '';
 const match=about.match(new RegExp('<h3>Итоги сезона '+year+'</h3><p>([\\s\\S]*?)</p>'));
 return (match?.[1]||'').replaceAll('<br>','\n').replaceAll('&lt;','<').replaceAll('&gt;','>').replaceAll('&amp;','&');
}
